import { filter, uniq } from 'lodash';

import urls from '../constants/urls';

import { gatherErrors } from '../utils/errorHandling';

import { paginationParams } from '../utils/pagination';

export const LOADING_NUMBERS_EXCLUSION_LIST =
  'exclusion_list/LOADING_NUMBERS_EXCLUSION_LIST';
export const NUMBERS_EXCLUSION_LIST_LOAD_FAILED =
  'exclusion_list/NUMBERS_EXCLUSION_LIST_LOAD_FAILED';
export const NUMBERS_EXCLUSION_LIST_LOAD_SUCCESS =
  'exclusion_list/NUMBERS_EXCLUSION_LIST_LOAD_SUCCESS';

export const CREATE_NUMBER_EXCLUSION_LIST_FAILED =
  'exclusion_list/CREATE_NUMBER_EXCLUSION_LIST_FAILED';
export const CREATE_NUMBER_EXCLUSION_LIST_SUCCESS =
  'exclusion_list/CREATE_NUMBER_EXCLUSION_LIST_SUCCESS';
export const CREATING_NUMBER_EXCLUSION_LIST =
  'exclusion_list/CREATING_NUMBER_EXCLUSION_LIST';

export const CHECKING_UNIQUENESS = 'exclusion_list/CHECKING_UNIQUENESS';
export const UNIQUENESS = 'exclusion_list/UNIQUENESS';
export const CHECKING_UNIQUENESS_FAILED =
  'exclusion_list/CHECKING_UNIQUENESS_FAILED';

export const DELETE_NUMBER_EXCLUSION_LIST_FAILED =
  'exclusion_list/DELETE_NUMBER_EXCLUSION_LIST_FAILED';
export const DELETE_NUMBER_EXCLUSION_LIST_SUCCESS =
  'exclusion_list/DELETE_NUMBER_EXCLUSION_LIST_SUCCESS';
export const DELETING_NUMBER_EXCLUSION_LIST =
  'exclusion_list/DELETING_NUMBER_EXCLUSION_LIST';

const initialState = {
  initialLoading: true,

  exclusionList: [],

  failedCreating: false,
  failedLoading: false,

  hasLoaded: false,

  isCreating: false,
  isLoading: false,

  page: 1,
  pages: 1,
  total: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_NUMBERS_EXCLUSION_LIST:
      return {
        ...state,
        failedLoading: false,
        isLoading: true,
      };

    case NUMBERS_EXCLUSION_LIST_LOAD_SUCCESS:
      return {
        ...state,
        failedLoading: false,
        hasLoaded: true,
        initialLoading: false,
        isLoading: false,
        exclusionList: action.payload.data.data.filter(Boolean),
        ...paginationParams(
          action.payload.headers['link'],
          action.payload.headers['x-total']
        ),
      };

    case NUMBERS_EXCLUSION_LIST_LOAD_FAILED:
      return {
        ...state,
        failedLoading: true,
        isLoading: false,
      };

    case CREATING_NUMBER_EXCLUSION_LIST:
      return {
        ...state,
        failedCreating: false,
        isCreating: true,
      };

    case CREATE_NUMBER_EXCLUSION_LIST_SUCCESS:
      return {
        ...state,
        isCreating: false,
      };

    case CREATE_NUMBER_EXCLUSION_LIST_FAILED:
      return {
        ...state,
        createErrors: gatherErrors(action.error, 'create_number_failed'),
        failedCreating: true,
        isCreating: false,
      };

    case DELETING_NUMBER_EXCLUSION_LIST:
      return {
        ...state,
        failedDelete: false,
        isDeleting: true,
      };

    case DELETE_NUMBER_EXCLUSION_LIST_SUCCESS:
      const newNumbers = uniq(
        filter(
          state.exclusionList,
          number => number.id !== action.meta.previousAction.number.id
        )
      );

      return {
        ...state,
        exclusionList: newNumbers,
        isDeleting: false,
      };

    case DELETE_NUMBER_EXCLUSION_LIST_FAILED:
      return {
        ...state,
        failedDelete: true,
        isDeleting: false,
      };

    default:
      return state;
  }
};

export const loadNumbersExclusionLists = (
  hospital,
  page,
  searchTerm
) => dispatch => {
  return dispatch({
    types: [
      LOADING_NUMBERS_EXCLUSION_LIST,
      NUMBERS_EXCLUSION_LIST_LOAD_SUCCESS,
      NUMBERS_EXCLUSION_LIST_LOAD_FAILED,
    ],
    payload: {
      request: {
        url: urls.hospitals.exclusionList.index(hospital.id),
        params: { page, search_string: searchTerm },
      },
    },
  });
};

export const createNumber = (hospitalId, params) => dispatch => {
  const numberParams = {
    name: params.name,
    number: params.number,
  };

  return dispatch({
    types: [
      CREATING_NUMBER_EXCLUSION_LIST,
      CREATE_NUMBER_EXCLUSION_LIST_SUCCESS,
      CREATE_NUMBER_EXCLUSION_LIST_FAILED,
    ],
    payload: {
      request: {
        method: 'post',
        url: urls.hospitals.exclusionList.create(hospitalId),
        data: { exclusion_list: numberParams },
      },
    },
  });
};

export const checkUniqueness = (hospitalId, params) => dispatch => {
  const numberParams = {
    name: params.name,
    number: params.number,
  };

  return dispatch({
    types: [CHECKING_UNIQUENESS, UNIQUENESS, CHECKING_UNIQUENESS_FAILED],
    payload: {
      request: {
        method: 'get',
        url: urls.hospitals.exclusionList.new(hospitalId),
        params: numberParams,
      },
    },
  });
};

export const deleteNumberExclusionLists = (hospital, number) => dispatch => {
  return dispatch({
    types: [
      DELETING_NUMBER_EXCLUSION_LIST,
      DELETE_NUMBER_EXCLUSION_LIST_SUCCESS,
      DELETE_NUMBER_EXCLUSION_LIST_FAILED,
    ],
    payload: {
      request: {
        method: 'delete',
        url: urls.hospitals.exclusionList.destroy(hospital.id, number.id),
      },
    },
    number: number,
  });
};
